// extracted by mini-css-extract-plugin
export var alignCenter = "_73-d";
export var bannerShown = "_73-6";
export var buttonContent = "_73-0";
export var cardList = "_73-1";
export var centerContent = "_73-2";
export var chevron = "_73-3";
export var closePanelButton = "_73-k";
export var conversationContextContainer = "_73-l";
export var conversationDetailContainer = "_73-4";
export var detailWrapper = "_73-7";
export var dropdownButton = "_73-e";
export var dropdownTitle = "_73-9";
export var fullHeight = "_73-5";
export var hidden = "_73-a";
export var icon = "_73-b";
export var mergeSuggestionWrapper = "_73-m";
export var panel = "_73-i";
export var portalButtonsWrapper = "_73-c";
export var right = "_73-j";
export var tableSummaryContainer = "_73-8";
export var tableSummaryHeader = "_73-g";
export var threeDotsButton = "_73-f";
export var wide = "_73-h";